<!--Footer Starts-->
<footer>
  <div class="container-fluid">
    <p class="copyright text-center">
      AIS {{ version }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&copy; {{ currentDate | date: 'yyyy' }}
      Artificial Intelligence System by
      <a href="https://www.nidaros.nl/" target="_blank">Nidaros</a>
    </p>
  </div>
</footer>
<!--Footer Ends-->
